import { render } from "./ConnectExchangeAccount.vue?vue&type=template&id=38c00b5b"
import script from "./ConnectExchangeAccount.vue?vue&type=script&lang=js"
export * from "./ConnectExchangeAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__